import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social-container"},[_c('h5',[_vm._v("Social")]),_c(VRow,{staticClass:"btn-wrapper"},_vm._l((_vm.social),function(item){return _c('a',{key:item.name,attrs:{"href":item.url}},[(item.lib == 'fa')?_c('i',{class:item.icon1}):(item.lib == 'mdi')?_c(VIcon,[_vm._v(_vm._s(item.icon2)+" ")]):_vm._e()],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }